function toggleAccordion() {
  var content = document.querySelector('#Ag-logo-nav .accordion-content');
  var arrow = document.querySelector('#Ag-logo-nav .arrow');
  var accordionTab = document.querySelector('#Ag-logo-nav .accordion-tab');
  if (content.style.maxHeight) {
    content.style.maxHeight = null;
    arrow.classList.remove('rotate');
    accordionTab.style.backgroundColor = "transparent";
  } else {
    content.style.maxHeight = content.scrollHeight + "px";
    arrow.classList.add('rotate');
    accordionTab.style.backgroundColor = "#A0B881";
  }
}
document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('#Ag-logo-nav a');
  
  // Add event listener to each link
  links.forEach(link => {
    link.addEventListener('click', function(event) {
      // Prevent the default behavior of opening a new tab/window
      event.preventDefault();
      // Open the link in the same tab/window
      window.location.href = this.href;
    });
  });
});



$(document).ready(function(){
  $("#foundation").click(function(){
    // Show first section and hide others
    $("#shopify-section-template--15833787105395__featured_product_w8inte").show();
    $("#shopify-section-template--15833787105395__featured_product_FFM3ct").hide();
    $("#shopify-section-template--15833787105395__featured_product_LHx9ky").hide();
  });
  
  $("#build").click(function(){
    // Show second section and hide others
    $("#shopify-section-template--15833787105395__featured_product_w8inte").hide();
    $("#shopify-section-template--15833787105395__featured_product_FFM3ct").show();
    $("#shopify-section-template--15833787105395__featured_product_LHx9ky").hide();
  });
  
  $("#grow").click(function(){
    // Show third section and hide others
    $("#shopify-section-template--15833787105395__featured_product_w8inte").hide();
    $("#shopify-section-template--15833787105395__featured_product_FFM3ct").hide();
    $("#shopify-section-template--15833787105395__featured_product_LHx9ky").show();
  });
});
// $(document).ready(function(){
//   $(".btn").click(function(){
//     // Remove active class from all buttons
//     $(".btn").removeClass("active");
//     // Add active class to the clicked button
//     $(this).addClass("active");
    
//     // Hide all sections
//     // $("section").hide();
    
//     // Show the corresponding section
//   //   var sectionId = $(this).attr("id").replace("btn_", "");
//   //   $("#" + sectionId).show();
//   // });
  
//   // Initially set "Foundation" button as active
//   $("#foundation").addClass("active");
// });

/// DO NOT DELET THIS CODE ****/////

(function () {
    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
  })();

jQuery('a[href^="http"]').not('a[href^="{{ shop.url }}"]').attr('target', '_blank');

// $(document).ready(function() {
//   $(".announcement-carousel").slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     arrows: false,
//     autoplayTimeout:5000,
//   });
// });

/* product-accordian-faq snippet */
let accHeading = document.querySelectorAll(".hs-accordion-title");
let accPanel = document.querySelectorAll(".hs-accordion-content");

for (let i = 0; i < accHeading.length; i++) {
// Execute whenever an accordion is clicked
accHeading[i].onclick = function() {
if (this.nextElementSibling.style.maxHeight) {
  hidePanels(this); 
  this.parentElement.classList.remove("active");
} else {
  showPanel(this); 
  accHeading[i].parentElement.classList.add("active");
}
};
}

function showPanel(elem) {
elem.classList.add("active");
elem.nextElementSibling.style.maxHeight = elem.nextElementSibling.scrollHeight + "px";
}

function hidePanels(elem) {
elem.nextElementSibling.removeAttribute("style");
elem.classList.remove("active");
elem.parentElement.classList.remove("active");
}

// function for on click dropdown open
window.onload = function() {
  var dropdownToggles = document.querySelectorAll(".site-nav--has-dropdown");
  dropdownToggles.forEach(function(dropdownToggle) {
    dropdownToggle.addEventListener("click", function(event) {
      event.stopPropagation();
      var dropdownMenu = this.querySelector(".site-nav__dropdown");
      dropdownToggles.forEach(function(otherDropdownToggle) {
        var otherDropdownMenu = otherDropdownToggle.querySelector(".site-nav__dropdown");
        if (otherDropdownMenu && otherDropdownMenu !== dropdownMenu) {
          otherDropdownMenu.classList.remove("open");
        }
      });

      dropdownMenu.classList.toggle("open");
    });
  });

  document.addEventListener("click", function(event) {
    var dropdowns = document.querySelectorAll(".site-nav__dropdown");
    dropdowns.forEach(function(dropdown) {
      if (dropdown.classList.contains("open") && !event.target.closest(".site-nav--has-dropdown")) {
        dropdown.classList.remove("open");
      }
    });
  });
};

//  Function for a sticky header
  window.onscroll = function() {headerFixed()};
  function headerFixed() {
    var headerr = document.getElementById("menuHeader");
    var stickyy = headerr.offsetTop;

    if (window.pageYOffset > stickyy) {
      headerr.classList.add("fixed-header");
    } else {
      headerr.classList.remove("fixed-header");
    }
  }



/// media resources tabs functions 
//This is used for usa region sections//
document.addEventListener('DOMContentLoaded', function() {
    const sections = ['home', 'menu1', 'menu2', 'menu3', 'menu4', 'menu5', 'menu6', 'menu7', 'menu8', 'menu9', 'menu10', 'menu11','menu12'];
    
    function showSection(sectionId) {
        sections.forEach(id => {
            const section = document.getElementById(id);
            if (section) {
                section.style.display = (id === sectionId) ? 'block' : 'none';
            }
        });
    }
    sections.forEach(id => {
        const element = document.getElementById(id + 'id');
        if (element) {
            element.addEventListener('click', function(event) {
                event.preventDefault(); 
                showSection(id);
            });
        } 
    });
});

$(document).ready(function() {
    // Define the URL to check against
    var targetUrl = 'https://shop.redmondagriculture.com/pages/media-resources#menu5';
    
    function updateActiveClass() {
        
        var currentUrl = window.location.href;
        if (currentUrl === targetUrl) 
          $('.tabs_style.researchTest').click();
        } 
    
    
    // Run the updateActiveClass function every 3 seconds
    setInterval(updateActiveClass, 5000);
});



